// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CalloutSection_wrapper__iVua_","card":"CalloutSection_card__LtuIF"};